import {
  clearAppToastItems,
  dismissAppToastItem,
  pushAppToastItem,
} from '~/utils/appToastSingleton'

/** @param {Parameters<typeof pushAppToastItem>[0]} payload */
export function pushAppToast(payload) {
  if (import.meta.server) return null
  return pushAppToastItem(payload)
}

export function dismissAppToast(id) {
  if (import.meta.server) return
  dismissAppToastItem(id)
}

export function clearAppToasts() {
  if (import.meta.server) return
  clearAppToastItems()
}
